import { format, parseISO, subDays } from "date-fns";
import { nowInIST, todayIST } from "./timezone";

/** Devotees can raise sick/O/mantras until 4:30am IST the next morning. */
export function earliestRaisableDateIST(now = nowInIST()): string {
  const hour = now.getHours();
  const minute = now.getMinutes();
  const today = todayIST();
  if (hour < 4 || (hour === 4 && minute < 30)) {
    return format(subDays(parseISO(today), 1), "yyyy-MM-dd");
  }
  return today;
}

export function canRaiseForDate(dateStr: string, now = nowInIST()): boolean {
  return dateStr >= earliestRaisableDateIST(now);
}

export const RAISE_CUTOFF_MESSAGE =
  "You can only submit this until 4:30am the next morning (before the morning program starts). After that the request is closed.";

export function closedRaiseDates(dates: string[], now = nowInIST()): string[] {
  return dates.filter((d) => !canRaiseForDate(d, now));
}

export function submitErrorMessage(
  error: unknown,
  dates: string[] = [],
  fallback = "Could not submit. Please try again."
): string {
  if (closedRaiseDates(dates).length > 0) return RAISE_CUTOFF_MESSAGE;
  const raw =
    error instanceof Error && error.message ? error.message : "";
  const lower = raw.toLowerCase();
  if (
    lower.includes("4:30") ||
    lower.includes("430") ||
    lower.includes("closed date") ||
    lower.includes("next morning")
  ) {
    return RAISE_CUTOFF_MESSAGE;
  }
  if (lower.includes("already raised")) {
    return raw;
  }
  if (raw && raw !== "[object Object]") return raw;
  return fallback;
}
